import {tryExceptAwait} from '@/utils'
import fabricsEndpoints from '@/api/fabrics'
import {_} from 'vue-underscore'

// initial state
const getDefaultState = () => {
  return {
    // fabrics: the list of user or vadain fabrics
    fabrics: [],
    // fabricDetails: key value store of detailed fabric
    // information, with the key being the fabric uuid
    fabricDetails: {},
    // count: the amount of fabrics
    count: null
  }
}

// getters
const getters = {
  getFabrics(state) {
    return state.fabrics
  },
  getFabricDetails(state) {
    return state.fabricDetails
  },
  getCount(state) {
    return state.count
  },
}

// mutations
const mutations = {
  setFabrics(state, fabrics) {
    state.fabrics = fabrics
  },
  setFabricDetails(state, fabricDetails) {
    state.fabricDetails = {
      ...state.fabricDetails,
      [fabricDetails.fabric_uuid]: fabricDetails
    }
  },
  setCount(state, count) {
    state.count = count
  },
}

// actions
const actions = {
  async loadFabrics({commit, state}, {queryParams}) {
    // fetch fabrics based on fabric option
    const {data, status} = await tryExceptAwait(fabricsEndpoints.getVadainFabrics, [queryParams]);
    // update state with response
    if (status === 200) {
      commit('setFabrics', data.results)
      commit('setCount', data.count)
    }
  },
  async loadFabricDetails({commit, state}, {urlParams}) {
    if (urlParams.fabricUuid in state.fabricDetails) {
      // do not do anything if fabric details already present in state
      return
    }
    // fetch fabric details based on fabric option
    const {data, status} = await tryExceptAwait(fabricsEndpoints.getVadainFabricDetails, [urlParams])
    // update state with response
    if (status === 200) {
      commit('setFabricDetails', data)
    }
  },
  async getFabricByArticleNumber({state}, articleId) {
    return _.find(state.fabrics, fabric => fabric.article_number === articleId)
  }
}

export default {
  namespaced: true,
  state: getDefaultState,
  getters,
  mutations,
  actions,
}
